enum MemberType {
    Extension = "extension",
    ExtensionGroup = "extensionGroup",
    Queue = "queue",
    RingGroup = "ringGroup"
}

export default MemberType;